import Vue from 'vue'

function createStubChat() {
  const noop = () => {}
  return {
    elementId: '',
    open: noop,
    minimize: noop,
    toggle: noop,
    displayChat: noop,
    hideChat: noop,
    setUser: noop,
    openPopout: noop,
    closePopout: noop
  }
}

/**
 * Maps Zoho Desk ASAP ($deskChat injection) to the $chat API used in the app.
 * @param {object} desk - Injected client from ~/plugins/zohodesk-asap
 */
function createZohoDeskChat(desk) {
  const chat = {
    elementId: 'zohodesk-asap',
    open: () => {
      desk.openChatWindow()
    },
    minimize: () => {
      desk.minimizeChatWindow()
    },
    toggle: () => {
      desk.toggleChatWindow()
    },
    displayChat: () => {
      desk.displayChatWidget()
    },
    hideChat: () => {
      desk.hideChatWidget()
    },
    setUser: user => {
      desk.setUser(user)
    },
    openPopout: () => {},
    closePopout: () => {}
  }

  chat.hideChat()

  return chat
}

export default ctx => {
  if (typeof window === 'undefined') {
    Vue.prototype.$chat = createStubChat()
    return
  }

  const desk = ctx.$deskChat
  if (!desk) {
    Vue.prototype.$chat = createStubChat()
    return
  }

  Vue.prototype.$chat = createZohoDeskChat(desk)
}
